module.exports = __webpack_public_path__ + "img/ZV1FB.9adead95.jpg";